import { Injectable } from '@angular/core';

import { UtilsService, leftPad } from '../utils.service';

@Injectable({
    providedIn: 'root'
})
export class DateUtilsService {

    constructor(private utilsService: UtilsService) { }

    /** Retorna a data formatada para um parâmetro HTTP */
    toHTTPParam(date: Date): string {
        return toHTTPParam(date);
    }

    /** Acrescenta dias na data informada onde se for informado que é somente dias uteis, irá contabilizar somente a quantidade de dias uteis acrescentados */
    acrescentarDias(dataAtual: Date, diasAcrescentar: number, somenteDiasUteis = false): Date {
        if (!dataAtual) {
            return null;
        }
        diasAcrescentar = diasAcrescentar && !isNaN(diasAcrescentar) ? Number(diasAcrescentar) : 0;

        const novaData = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), dataAtual.getDate(), dataAtual.getHours(), dataAtual.getMinutes(), dataAtual.getSeconds(), dataAtual.getMilliseconds());
        if (!somenteDiasUteis) {
            novaData.setDate(novaData.getDate() + diasAcrescentar);
        } else {
            let diasUteisAcrescentados = 0;
            while (diasUteisAcrescentados < diasAcrescentar) {
                novaData.setDate(novaData.getDate() + 1);
                while (novaData.getDay() === 0 || novaData.getDay() === 6) {
                    novaData.setDate(novaData.getDate() + 1);
                }
                diasUteisAcrescentados++;
            }
        }

        // const novaData = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), dataAtual.getDate(), dataAtual.getHours(), dataAtual.getMinutes(), dataAtual.getSeconds(), dataAtual.getMilliseconds());
        // novaData.setDate(novaData.getDate() + diasAcrescentar);

        // if (somenteDiasUteis) {
        //     while (novaData.getDay() === 0 || novaData.getDay() === 6) {
        //         novaData.setDate(novaData.getDate() + 1);
        //     }
        // }

        return novaData;
    }

    /** Obtem o trimestre da data informada */
    getQuarter(dateRef: Date): number {
        if (!dateRef) {
            return null;
        }

        // Primeiro obtem o mês da data
        const month = dateRef.getMonth();

        // Dividindo o mês por 3 (quantidade de meses de um trimestre) + 1 para somar ao valor inteiro da divisão
        return Math.floor(month / 3) + 1;
    }

    /** Obtem o semestre da data informada */
    getHalfYear(dateRef: Date): number {
        if (!dateRef) {
            return null;
        }

        // Primeiro obtem o mês da data
        const month = dateRef.getMonth();

        // Dividindo o mês por 6 (quantidade de meses de um semestre) + 1 para somar ao valor inteiro da divisão
        return Math.floor(month / 6) + 1;
    }
}

// Function exportada para poder ser utilizada em classes sem a DI (Dependency Injection)
/** Retorna a data formatada para um parâmetro HTTP */
export function toHTTPParam(date: Date, withTime = false): string {
    if (!date) {
        return '';
    }
    // Verificando se não é um objeto do tipo Date
    if (typeof date.getFullYear !== 'function') {
        date = new Date(date);
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    let format = `${year}-${leftPad(month, 2)}-${leftPad(day, 2)}`

    // Se for para formatar com o horário então colocamos a formatação do horário tudo zerada
    if (withTime) {
        format += 'T00:00:00-03:00';
    }

    return format;
}
